import { ERROR } from "constant/message";
import { MONTH_NAMES } from "constant";

const dateFormat = (date) => {
  try {
    // eslint-disable-next-line prettier/prettier
    const dateF = ` ${String(date.getDate()).padStart(2, "0")}/${MONTH_NAMES[date.getMonth()]
      // eslint-disable-next-line prettier/prettier
      }/${date.getFullYear()}`;
    return dateF;
  } catch (error) {
    console.log("dateFormat eror", error);
    return ERROR;
  }
};
export default dateFormat;
export const formatDateYMD = (date) => {
  return date ? new Date(date).toISOString().split("T")[0] : ""; // Format YYYY-MM-DD
};

export const calculateAge = (dateOfBirth) => {
  const today = new Date();
  const birthDate = new Date(dateOfBirth);

  let years = today.getFullYear() - birthDate.getFullYear();
  let months = today.getMonth() - birthDate.getMonth();

  // Adjust if the current month is before the birth month
  if (months < 0) {
    years -= 1;
    months += 12;
  }

  return { years, months };
};
